import * as React from "react"

export function Shield(props) {
  return (
    <svg
    width={43}
      height={43}
      viewBox="0 0 43 43"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
    <g clipPath="url(#clip0_29_92)" fill="#currentColor">
      <path
               d="M35.556 6.969L21.62 2.219A2.016 2.016 0 0021 2.133c-.226 0-.451.029-.62.086L6.445 6.969c-.34.114-.62.508-.62.87v19.785c0 .361.234.837.517 1.062l14.138 11.017c.144.11.328.168.517.168a.839.839 0 00.517-.168L35.65 28.686c.283-.221.517-.697.517-1.062V7.838c.008-.36-.271-.75-.612-.87zm-7.07 7.005l-8.72 12.005a.66.66 0 01-1.067 0l-5.184-7.136a.33.33 0 01.266-.521h2.264c.21 0 .41.102.533.27l2.654 3.65 6.19-8.522a.66.66 0 01.533-.271h2.264a.333.333 0 01.266.525z"
        fill="#currentColor"
      />
      </g>
    </svg>
  );
}
